import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * Blog CTA banner — narrower & taller variant with an Indian professional photo
 * (centre-cropped from /cta-professional.webp). Light beige EasyWorks palette,
 * orange "easy" + black "works" logo. Whole banner is clickable → /contact-us.
 */
const BlogCTABanner = ({ testId = 'blog-cta-banner' }) => (
  <Link
    to="/contact-us"
    data-testid={testId}
    className="block my-10 mx-auto max-w-3xl rounded-2xl overflow-hidden border border-[#F39200]/25 bg-[#FAF2E8] shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all"
  >
    <div className="relative grid md:grid-cols-2 items-stretch overflow-hidden">
      {/* subtle orange glow anchored top-left */}
      <div
        className="absolute -left-24 -top-24 w-72 h-72 rounded-full blur-3xl opacity-30 pointer-events-none"
        style={{ background: 'radial-gradient(closest-side, #F39200, transparent 70%)' }}
      />

      {/* Left copy — symmetrical padding, centred vertically */}
      <div className="p-7 md:p-9 relative z-10 flex flex-col justify-center">
        <div className="flex items-baseline gap-1 select-none">
          <span className="font-extrabold text-2xl md:text-3xl tracking-tight text-[#F39200]">easy</span>
          <span className="font-extrabold text-2xl md:text-3xl tracking-tight text-neutral-900">works</span>
        </div>
        <h3 className="mt-5 text-xl md:text-[26px] font-extrabold leading-[1.2] tracking-tight text-neutral-900">
          Get Expert GST and<br />Compliance Services
        </h3>
        <div className="mt-2 text-xl md:text-[26px] font-extrabold leading-[1.2] tracking-tight text-[#F39200]">
          with Easy Works.
        </div>
        <p className="mt-4 text-[11px] md:text-xs tracking-[0.18em] font-semibold text-neutral-700">
          VPOB · COMPLIANCE · ACCOUNTING · AUDIT
        </p>
        <span className="mt-5 inline-flex w-fit items-center gap-2 bg-[#F39200] hover:bg-neutral-900 text-white text-xs font-bold uppercase tracking-widest px-5 py-3 rounded-md transition-colors">
          Contact us <ArrowRight size={14} />
        </span>
      </div>

      {/* Right — taller photo of an Indian professional (centre-cropped) */}
      <div className="relative min-h-[360px] md:min-h-[440px]">
        <img
          src="/cta-professional.webp"
          alt="EasyWorks Indian compliance specialist"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: '50% 30%' }}
          loading="lazy"
        />
        {/* soft left-side beige fade so the photo blends into the copy panel */}
        <div className="absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-[#FAF2E8] via-[#FAF2E8]/40 to-transparent hidden md:block" />
      </div>
    </div>
  </Link>
);

export default BlogCTABanner;
